function escapeHtml(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

export function renderUnavailableBlock(className: string, message: string, detail?: string): string {
  const safeMessage = escapeHtml(message);
  const safeDetail = detail ? escapeHtml(detail) : '';

  return `
    <div class="${className}" style="padding:2rem;text-align:center;">
      <div class="text-muted text-sm">${safeMessage}</div>
      ${safeDetail ? `<div class="text-muted text-xs" style="margin-top:0.5rem;">${safeDetail}</div>` : ''}
    </div>
  `;
}
